import { render, staticRenderFns } from "./DownloadFileBlock.vue?vue&type=template&id=53b15ae0&scoped=true"
import script from "./DownloadFileBlock.vue?vue&type=script&lang=js"
export * from "./DownloadFileBlock.vue?vue&type=script&lang=js"
import style0 from "./DownloadFileBlock.vue?vue&type=style&index=0&id=53b15ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b15ae0",
  null
  
)

export default component.exports